import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { shiftService } from 'ogp/services';
import {
  BulkShiftCreationCSVUploadPayload,
  BulkShiftCreationCSVUploadResponse,
} from 'ogp/services/shift-service.types';
import { QUERY_KEYS } from 'api/query-keys';

type BulkShiftCreationMutationOptions = UseMutationOptions<
  BulkShiftCreationCSVUploadResponse,
  Error,
  BulkShiftCreationCSVUploadPayload
>;

export const useBulkShiftCreation = () => {
  const queryClient = useQueryClient();

  const mutationFn = async (data: BulkShiftCreationCSVUploadPayload) =>
    await shiftService.bulkShiftCreationCSVUpload(data);

  const options: BulkShiftCreationMutationOptions = {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.shifts());
    },
  };

  return useMutation(mutationFn, options);
};
